import { render, staticRenderFns } from "./SendTestEmailModal.vue?vue&type=template&id=14b3f0a2&scoped=true"
import script from "./SendTestEmailModal.vue?vue&type=script&lang=js"
export * from "./SendTestEmailModal.vue?vue&type=script&lang=js"
import style0 from "@/components/modal/BasicModal.scss?vue&type=style&index=0&id=14b3f0a2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b3f0a2",
  null
  
)

export default component.exports